export let dataProps = {
    id: 0,
    bank_name: '',
    account_number: '',
    tally_sub_group_id: null
}


// WEBPACK FOOTER //
// ./src/store/modules/bankMaster/properties.js